import { GoArrowLeft } from "react-icons/go";
import Accordion from "react-bootstrap/Accordion";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Loader from "../../components/common/Common/Loader";
import "../../pages/objectPhotography/Objectphotography.scss";
import Table from "react-bootstrap/Table";
import { RiHistoryLine } from "react-icons/ri";
import { TbMessageCircleCheck } from "react-icons/tb";
import "./conditionAssessmentView.scss";

import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getObjectConservationDetails } from "../../api/actions/object";
import { useFormik } from "formik";
import "../objectPhotography/Objectphotography.scss";
// import "react-image-gallery/styles/scss/image-gallery.scss"
import "react-image-gallery/styles/css/image-gallery.css";
import notFound from "../../assets/images/common/image-not-found.png";
import { RiVipCrownFill } from "react-icons/ri";
import star from "../../assets/images/category/star.png";
import ReactImageGallery from "react-image-gallery";
import Commentdrawer from "./commentdrawer";
import Objecthistorydrawer from "./Objecthistorydrawer";
import Tooltip from "@mui/material/Tooltip";
import ImageEnlarge from "../../components/common/Common/imageEnlarge";
import { Md3dRotation } from "react-icons/md";
import TransitModal from "../Transit form/TransitModal";
import {
  CONSERVATION_KANBAN,
  GLOBAL_SEARCH,
  HOME_URL,
  KANBAN_BOARD,
  LIST_CATEGORY,
  LIST_LOCATION,
  LIST_MATERIAL,
  lIST_NOTIFICATION,
  LIST_OBJECT,
  OBJECT_PIN,
  QR_LOCATION_MANAGMENT,
} from "../../constants/routers";
import { HiOutlinePlus } from "react-icons/hi";

// const Model = ({ imageUrl }) => {
//     console.log(imageUrl, "3dimage");

//     const { scene } = useGLTF(imageUrl)
//     return <primitive scale={[0.8, 0.8, 0.8]} // scale down if too large
//         position={[0, -0.5, 0]}
//         rotation={[0, Math.PI / 2, 0]}
//         object={scene} />
// }

const Objectadmindetails = ({
  onCloseObject,
  fromList = false,
  objectId = "",
}) => {
  const [showImage, setShowImage] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [transitHistory, setTransitHistory] = useState({
    show: false,
    loading: false,
    data: [],
    totalCount: 0,
    page: 1,
  });
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem("user_info"));
  const [update] = useState(false);
  const [showImageEnlarge, setShowEnlargeImage] = useState({
    parentIndex: "",
    childIndex: "",
    imageIndex: "",
    imageIdTitle: "",
    image: "",
    show: false,
    title: "",
    isEdit: false,
  });
  const location = useLocation();
  const fromNotification = location.state?.fromNotification || false;
  const fromCollection = location.state?.fromCollection || false;
  const fromDigitalKanban = location.state?.fromDigitalKanban || false;
  const fromconservationkanban =
    location.state?.fromconservationkanban || false;
  const fromGlobal = location.state?.fromGlobal || false;
  const fromMaterial = location.state?.fromMaterial || false;
  const fromCategory = location.state?.fromCategory || false;
  const fromLocation = location.state?.fromLocation || false;
  const locationType = location?.state?.locationType;
  const floorPlanObjectId = location?.state?.floorPlanObjectId;
  const fromPin = location.state?.fromPin || false;

  const [isOpen, setIsOpen] = React.useState(false);

  const routeParams = useParams();
  const id = fromList ? objectId : routeParams.id;

  const formik = useFormik({
    initialValues: {
      object_details: "",
      museum: userData.museum,
      images: [],
      reference_image: "",
      object_name: "",
      remarks: "",
      original_location: "",
      iconic_object: false,
      material: [],
      provenance: "",
      dateable_time_period: "",
      category: "",
      height: "",
      depth: "",
      width: "",
      dimensions: [],
      description: "",
      preliminary_condition_assessment: "",
      inscription_or_markers: "",
      function_or_usages: [],
      acquisition_method: "",
      tags: [],
      additional_notes: "",
      transit_location: "",
      selectedCategory: "",
      selectedMaterial: [],
      selectedTransit: "",
      selectedAcquistion: "",
      selectedOriginalLocation: "",
      conservation_grade: "",
      selectedConservation: "",
      selctedObject: "",
      preview_image: [],
      object_qr_code: [],
      period_end_date: "",
      period_start_date: "",
      period: "",
      accession_number: "",
      investigation_details: [],
      related_museum_object_name: "",
      techinques_used: "",
      physical_description: "",
    },
  });

  const handleBack = () => {
    if (fromList) {
      onCloseObject();
    } else if (fromCollection) {
      navigate(
        `/${
          userData.museum_name
            ? userData?.museum_name?.split(" ").join("_")
            : "Nefos"
        }/${LIST_OBJECT}`
      );
    } else if (fromDigitalKanban) {
      navigate(
        `/${
          userData.museum_name
            ? userData?.museum_name?.split(" ").join("_")
            : "Nefos"
        }/${KANBAN_BOARD}`
      );
    } else if (fromconservationkanban) {
      navigate(
        `/${
          userData.museum_name
            ? userData?.museum_name?.split(" ").join("_")
            : "Nefos"
        }/${CONSERVATION_KANBAN}`
      );
    } else if (fromGlobal) {
      navigate(
        `/${
          userData.museum_name
            ? userData?.museum_name?.split(" ").join("_")
            : "Nefos"
        }/${GLOBAL_SEARCH}`
      );
    } else if (fromMaterial) {
      navigate(
        `/${
          userData.museum_name
            ? userData?.museum_name?.split(" ").join("_")
            : "Nefos"
        }/${LIST_MATERIAL}`
      );
    } else if (fromCategory) {
      navigate(
        `/${
          userData.museum_name
            ? userData?.museum_name?.split(" ").join("_")
            : "Nefos"
        }/${LIST_CATEGORY}`
      );
    } else if (fromLocation) {
      navigate(
        `/${
          userData.museum_name
            ? userData?.museum_name?.split(" ").join("_")
            : "Nefos"
        }/${QR_LOCATION_MANAGMENT}/${floorPlanObjectId}?type=${locationType}`
      );
    } else if (fromPin) {
      navigate(
        `/${
          userData.museum_name
            ? userData?.museum_name?.split(" ").join("_")
            : "Nefos"
        }/${OBJECT_PIN}`
      );
    } else if (fromNotification) {
      navigate(
        `/${
          userData.museum_name
            ? userData?.museum_name?.split(" ").join("_")
            : "Nefos"
        }/${lIST_NOTIFICATION}`
      );
    } else {
      navigate(
        `/${
          userData.museum_name
            ? userData?.museum_name?.split(" ").join("_")
            : "Nefos"
        }/${HOME_URL}`
      );
    }
  };
  const [isOpenhistory, setIsOpenhistory] = React.useState(false);
  const toggleDrawerhistory = () => {
    setIsOpenhistory((prevState) => !prevState);
  };

  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
  };
  useEffect(() => {
    setLoading(true);
    getObjectConservationDetails({ id })((response) => {
      const dataValue = response?.data;
      if (response?.status) {
        setLoading(false);
        formik?.setValues({
          ...formik?.values,
          remarks: dataValue?.conservation_details?.remarks,
          is_emergency: dataValue?.conservation_details?.is_emergency,
          object_details: dataValue?.object_details,
          graphical_represenatation:
            dataValue?.conservation_details?.graphical_represenatation,
          invasive_or_non_vasive:
            dataValue?.conservation_details?.invasive_or_non_vasive,
          investigation_id: dataValue?.conservation_details?.investigation_id,
          object_handling_guidelines:
            dataValue?.conservation_details?.object_handling_guidelines,
          proposed_treatment:
            dataValue?.conservation_details?.proposed_treatment,
          re_shoot: dataValue?.conservation_details?.re_shoot,
          recommended_storage:
            dataValue?.conservation_details?.recommended_storage,
          result: dataValue?.conservation_details?.result,
          sample_details: dataValue?.conservation_details?.sample_details,
          stability: dataValue?.conservation_details?.stability,
          stabilization_guidelines:
            dataValue?.conservation_details?.stabilization_guidelines,
          stratigraphic_assessment:
            dataValue?.conservation_details?.stratigraphic_assessment,
          investigation_details:
            dataValue?.conservation_details?.investigation_details,
          techinques_used: dataValue?.conservation_details?.techinques_used,
          physical_description:
            dataValue?.conservation_details?.physical_description,
        });
      }
    });
  }, [update, id]);

  useEffect(() => {
    if (fromNotification) {
      setIsOpen(true);
      // navigate(location.pathname, { replace: true, state: null });
    }
  }, [fromNotification]);

  const formikValues = formik?.values;
  const objectData = formik?.values?.object_details;

  const newImage = objectData?.object_images?.slice(4).map((li) => ({
    original: li?.images,
    thumbnail: li?.thumbnail,
  }));

  useEffect(() => {
    const handleMouseMove = (event) => {
      const mouseX = event.clientX;
      const inRightSide = mouseX >= window.innerWidth * 0.8;

      setIsVisible(inRightSide);
    };

    document.addEventListener("mousemove", handleMouseMove);

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  useEffect(() => {
    const handleMouseMove = (event) => {
      const mouseX = event.clientX;
      const inRightSide = mouseX >= window.innerWidth * 0.8;

      setIsVisible(inRightSide);
    };

    document.addEventListener("mousemove", handleMouseMove);

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  const closehandler = () => {
    setIsOpenhistory(false);
    setIsOpen(false);
  };

  const transitHistoryShowHandler = () => {
    setTransitHistory({
      show: true,
    });
  };

  return (
    <>
      <section className="dashboard asset-management light-wrapper dark-wrapper">
        {showImageEnlarge?.show && (
          <ImageEnlarge
            imageData={showImageEnlarge}
            setShowReference={setShowEnlargeImage}
          />
        )}
        <div className="add-building-container">
          <div
            className="notification"
            style={{
              display: isVisible ? "block" : "none",
              opacity: isVisible ? 1 : 0,
              visibility: isVisible ? "visible" : "hidden",
            }}
          >
            <Tooltip
              title="Discussions"
              placement="left"
              sx={{
                backgroundColor: "#E2F1FF ",
              }}
            >
              <div className="cmt-icon-query" onClick={toggleDrawer}>
                <TbMessageCircleCheck size={21} />
              </div>
            </Tooltip>
            <Tooltip title="History" placement="left">
              <div className="cmt-icon-history" onClick={toggleDrawerhistory}>
                <RiHistoryLine size={20} />
              </div>
            </Tooltip>
          </div>
          <Container>
            <div className="add-category-title-row">
              <div className=" title-row-content">
                <div className="title-icon " onClick={handleBack}>
                  <GoArrowLeft />
                </div>
                <div className=" titles">
                  <p>Back to home page</p>
                  <h4>{"Object detail page"}</h4>
                </div>
              </div>
            </div>
            {loading ? (
              <Loader />
            ) : (
              <Form
                style={{ marginRight: isOpen ? "30%" : "0" }}
                onSubmit={formik.handleSubmit}
              >
                <div onClick={closehandler} className="add-object-field-box">
                  <Row className="primary-field-row">
                    <Modal
                      style={{
                        backgroundColor: "transparent",
                        border: "none",
                        boxShadow: "none", // Remove shadow if present
                      }}
                      className="image-gallery-modal"
                      onHide={() => setShowImage(false)}
                      show={showImage}
                    >
                      <Modal.Header
                        closeButton
                        style={{ border: "none" }}
                      ></Modal.Header>
                      <ReactImageGallery items={newImage} />
                    </Modal>
                    <div className="add-object">
                      <div className="feature-full-div">
                        <div className="feature-left">
                          <div style={{ marginBottom: "35px" }}>
                            <h4 style={{ fontWeight: "600" }}>
                              Object information
                            </h4>
                          </div>
                          <ul className="field-ul">
                            <li className="field-li row">
                              <div className="col-md-3">Object name</div>
                              <div className="col-md-7">
                                <p
                                  style={{
                                    maxWidth: "380px",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  {objectData?.object_name}
                                </p>
                              </div>
                            </li>
                            <li className="field-li row">
                              <div className="col-md-3">Materials</div>
                              <div
                                className="col-md-7"
                                style={{ display: "flex", gap: "5px" }}
                              >
                                <div
                                  className="material_tags"
                                  style={{ flexWrap: "wrap" }}
                                >
                                  {objectData?.material?.map((li) => (
                                    <p className="p_tag">
                                      {li?.material_name}{" "}
                                    </p>
                                  ))}
                                </div>
                              </div>
                            </li>
                            <li className="field-li row">
                              <div className="col-md-3">Primary category</div>
                              <div
                                className="col-md-7"
                                style={{
                                  display: "flex",
                                  gap: "6px",
                                  alignItems: "center",
                                }}
                              >
                                {objectData?.prime_category_name}
                                {objectData?.prime_category_code && (
                                  <p style={{ color: "gray" }}>
                                    {` (${objectData?.prime_category_code}) `}
                                  </p>
                                )}
                                {objectData?.prime_key_category === "True" && (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <img
                                      style={{ height: "18px" }}
                                      alt="key-category"
                                      src={star}
                                    />
                                  </div>
                                )}
                              </div>
                            </li>
                            <li className="field-li row">
                              <div className="col-md-3">Subcategory</div>
                              <div
                                className="col-md-7"
                                style={{ display: "flex", gap: "6px" }}
                              >
                                {objectData?.category_name
                                  ?.charAt(0)
                                  .toUpperCase() +
                                  objectData?.category_name
                                    ?.slice(1)
                                    .toLowerCase()}
                                {objectData?.category_code && (
                                  <p style={{ color: "gray" }}>
                                    {` (${objectData?.category_code}) `}
                                  </p>
                                )}
                                {objectData?.key_category === "True" && (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <img
                                      style={{ height: "18px" }}
                                      alt="key-catgory"
                                      src={star}
                                    />
                                  </div>
                                )}
                              </div>
                            </li>
                            {objectData?.descriptors?.length > 0 && (
                              <li className="field-li row">
                                <div className="col-md-3">
                                  <p>Category descriptors</p>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    gap: "20px",
                                    flexWrap: "wrap",
                                  }}
                                  className="col-md-7"
                                >
                                  {objectData?.descriptors?.map((li) => {
                                    let multiDEscr = [];
                                    if (
                                      li?.attribute_type === "Multiple dropdown"
                                    ) {
                                      try {
                                        multiDEscr = li?.description
                                          ? JSON.parse(li.description)
                                          : [];
                                      } catch (e) {
                                        console.error(
                                          "Failed to parse JSON for description:",
                                          li.description
                                        );
                                        multiDEscr = [li.description]; // fallback to single string in array
                                      }
                                    }
                                    return (
                                      <div style={{ display: "flex" }}>{`${
                                        li?.attribute_name
                                          ? li?.attribute_name
                                              .charAt(0)
                                              .toUpperCase() +
                                            li?.attribute_name.slice(1)
                                          : ""
                                      } - ${
                                        li?.attribute_type ===
                                        "Multiple dropdown"
                                          ? multiDEscr?.map((li) => ` ${li}`)
                                          : li?.description
                                      } `}</div>
                                    );
                                  })}
                                </div>
                              </li>
                            )}
                            <li className="field-li row">
                              <div className="col-md-3">Object label</div>
                              <div
                                className="col-md-7"
                                style={{
                                  display: "flex",
                                  gap: "11px",
                                  alignItems: "center",
                                }}
                              >
                                {objectData?.object_label}
                              </div>
                            </li>
                            <li className="field-li row">
                              <div
                                className="col-md-3"
                                style={{ overflowWrap: "break-word" }}
                              >
                                Number of parts
                              </div>
                              <div className="col-md-7">
                                {objectData?.number_of_parts}
                              </div>
                            </li>
                            <li className="field-li row">
                              <div
                                className="col-md-3"
                                style={{ overflowWrap: "break-word" }}
                              >
                                Number of missing pieces
                              </div>
                              <div className="col-md-7">
                                {objectData?.number_of_missing_pieces}
                              </div>
                            </li>
                            <li className="field-li row">
                              <div className="col-md-3">
                                <p>Dimensions(cm)</p>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  gap: "20px",
                                  flexWrap: "wrap",
                                }}
                                className="col-md-7"
                              >
                                <div style={{ display: "flex" }}>
                                  Height-<p>{objectData?.height}</p>
                                </div>
                                <div style={{ display: "flex" }}>
                                  Width-<p>{objectData?.width}</p>
                                </div>
                                <div style={{ display: "flex" }}>
                                  Depth-<p>{objectData?.depth}</p>
                                </div>
                                {objectData?.other_dimensions?.map((li) => (
                                  <div style={{ display: "flex" }}>
                                    {`${li?.dimension_name}-`}
                                    <p>{li?.dimension_value}</p>
                                  </div>
                                ))}
                              </div>
                            </li>
                            <li className="field-li row">
                              <div className="col-md-3">Related objects</div>
                              <div className="col-md-7">
                                <div
                                  className="material_tags"
                                  style={{ flexWrap: "wrap" }}
                                >
                                  {objectData?.related_museum_object?.map(
                                    (li) => (
                                      <p className="p_tag">{li?.label}</p>
                                    )
                                  )}
                                </div>
                              </div>
                            </li>
                            <li className="field-li row">
                              <div className="col-md-3">
                                Inscriptions or markers
                              </div>
                              <div className="col-md-7">
                                {objectData?.inscription_or_markers
                                  ?.charAt(0)
                                  .toUpperCase() +
                                  objectData?.inscription_or_markers
                                    ?.slice(1)
                                    .toLowerCase()}
                              </div>
                            </li>
                          </ul>
                        </div>
                        <div className=" col-lg-4 feature-right-cons ">
                          <div className="img-main-cons">
                            <div className=" img-cons">
                              {objectData?.iconic_object && (
                                <div className="admin_detail_iconic">
                                  <RiVipCrownFill />
                                </div>
                              )}

                              <div className="qr-code-main-div-cons-admin">
                                <div className="">
                                  <img
                                    className=""
                                    src={objectData?.object_qr_code}
                                    alt="QR code"
                                  />
                                </div>
                                <div
                                  style={{
                                    height: "20%",
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "end",
                                  }}
                                >
                                  {/* <p>{objectData?.accession_number}</p> */}
                                </div>
                              </div>
                              {objectData?.reference_image ? (
                                <img
                                  onClick={() => {
                                    let multiImage = [
                                      {
                                        images: objectData?.reference_image,
                                        thumbnail: objectData?.reference_image,
                                      },
                                      ...objectData?.object_images,
                                    ];

                                    if (multiImage.length > 0) {
                                      const lastItem =
                                        multiImage[multiImage.length - 1];
                                      if (
                                        typeof lastItem?.images === "string" &&
                                        lastItem.images.includes(".glb")
                                      ) {
                                        multiImage = multiImage.slice(0, -1); // remove last element
                                      }
                                    }

                                    setShowEnlargeImage({
                                      image:
                                        objectData?.object_images?.length > 1
                                          ? multiImage
                                          : objectData?.reference_image,
                                      title: "Reference image",
                                      show: true,
                                      isEdit: false,
                                    });
                                  }}
                                  src={objectData?.reference_image}
                                  alt="ref-img"
                                  style={{ cursor: "pointer" }}
                                  height={"330px"}
                                  width={"100%"}
                                />
                              ) : (
                                <img
                                  src={notFound}
                                  height={"330px"}
                                  width={"100%"}
                                  alt="error-image"
                                />
                              )}
                            </div>
                            <div style={{ height: "20%", width: "100%" }}>
                              {/* <p>{objectData?.accession_number}</p> */}
                            </div>
                          </div>

                          <div className="multiple-image-box">
                            {objectData?.object_images
                              ?.filter((li) => {
                                const img = li?.images;
                                return !(
                                  typeof img === "string" &&
                                  img.includes(".glb")
                                );
                              })
                              ?.slice(0, 4)
                              .map((li, indexOfimage) => (
                                <>
                                  <div
                                    className={
                                      objectData?.object_images?.length > 4 &&
                                      indexOfimage === 3
                                        ? "image-box-more"
                                        : "image-box"
                                    }
                                  >
                                    <div
                                    // onClick={() => {

                                    //     if (indexOfimage <= 3 && objectData?.object_images?.length < 4) {
                                    //         setShowEnlargeImage({
                                    //             show: true,
                                    //             image: li?.thumbnail,
                                    //             title: "Reference image",
                                    //             isEdit: false
                                    //         });
                                    //     }
                                    // }}
                                    // style={{ cursor: objectData?.object_images?.length < 4 && "pointer" }}
                                    >
                                      {
                                        li?.images && (
                                          <img
                                            src={li?.thumbnail || li?.images}
                                            alt="multi-img"
                                          />
                                        )

                                        // <Canvas
                                        //     key={`preview-${indexOfimage}-${li?.images}`}
                                        //     camera={{ position: [0, 0, 1], fov: 50 }}
                                        //     gl={{
                                        //         preserveDrawingBuffer: true,
                                        //         antialias: true,
                                        //         alpha: true,
                                        //         powerPreference: "high-performance"
                                        //     }}
                                        // >
                                        //     <ambientLight intensity={1.2} />
                                        //     <directionalLight position={[5, 5, 5]} intensity={1.5} />
                                        //     <directionalLight position={[-5, 5, -5]} intensity={0.8} />
                                        //     <pointLight position={[0, 10, 0]} intensity={1.5} />
                                        //     <Suspense fallback={null}>
                                        //         <Bounds fit clip observe margin={1.2}>
                                        //             <Model
                                        //                 key={`preview-model-${indexOfimage}`}
                                        //                 imageUrl={li?.images}
                                        //             />
                                        //         </Bounds>
                                        //     </Suspense>
                                        // </Canvas>
                                      }
                                    </div>
                                    {li?.image_position === "glb" && (
                                      <div
                                        style={{
                                          position: "absolute",
                                          top: "0",
                                          right: "0",
                                        }}
                                        className="3d-icon-container"
                                      >
                                        <Md3dRotation />
                                      </div>
                                    )}
                                    <div
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        let multiImage = [
                                          {
                                            images: objectData?.reference_image,
                                            thumbnail:
                                              objectData?.reference_image,
                                          },
                                          ...objectData?.object_images,
                                        ];

                                        if (multiImage.length > 0) {
                                          const lastItem =
                                            multiImage[multiImage.length - 1];
                                          if (
                                            typeof lastItem?.images ===
                                              "string" &&
                                            lastItem.images.includes(".glb")
                                          ) {
                                            multiImage = multiImage.slice(
                                              0,
                                              -1
                                            ); // remove last element
                                          }
                                        }

                                        setShowEnlargeImage({
                                          image:
                                            objectData?.object_images?.length >
                                            1
                                              ? multiImage
                                              : objectData?.reference_image,
                                          title: "Reference image",
                                          show: true,
                                          isEdit: false,
                                        });
                                      }}
                                      className="plus-icon"
                                    >
                                      <HiOutlinePlus />
                                      <p>
                                        {objectData?.object_images?.length - 4}
                                      </p>
                                    </div>
                                    {objectData?.object_images?.length > 4 &&
                                      indexOfimage === 3 && (
                                        <div>
                                          <div className="image-box-more-overlay"></div>
                                        </div>
                                      )}
                                  </div>
                                  {/* {objectData?.object_images?.length > 4 && indexOfimage === 3 &&
                                                                        <div className='image-box-more-overlay image-box-more-overlay-black ' ></div>
                                                                    } */}
                                </>
                              ))}
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              marginTop: "15px",
                            }}
                          >
                            <p>{objectData?.accession_number}</p>
                          </div>
                        </div>
                      </div>
                      <div
                        className="feature-full-div"
                        style={{ marginTop: "13px", flexDirection: "column" }}
                      >
                        {/* <div> */}
                        <ul className="field-ul" style={{ width: "100%" }}>
                          <li className="field-li row">
                            <div className="col-md-2">
                              Preliminary assessment{" "}
                            </div>
                            <div className="col-md-7">
                              {objectData?.preliminary_condition_assessment
                                ?.charAt(0)
                                .toUpperCase() +
                                objectData?.preliminary_condition_assessment
                                  ?.slice(1)
                                  .toLowerCase()}
                            </div>
                          </li>
                          <li className="field-li row">
                            <div className="col-md-2">Provenance</div>
                            <div className="col-md-7">
                              {objectData?.provenance &&
                                objectData.provenance.charAt(0).toUpperCase() +
                                  objectData.provenance.slice(1).toLowerCase()}
                            </div>
                          </li>
                          <li className="field-li row">
                            <div className="col-md-2">Dateable time period</div>
                            <div className="dateable-time-div col-md-6">
                              <div className="dateable-input-select-div">
                                <p>{objectData?.period}</p>
                              </div>
                              <div className="dateable-input-select-div">
                                <p>{objectData?.period_start_date}</p>
                              </div>{" "}
                              -
                              <div className="dateable-input-select-div">
                                <p>{objectData?.period_end_date}</p>
                              </div>
                            </div>
                          </li>

                          <li className="field-li row">
                            <div className="col-md-2">Acquisition method </div>
                            <div className="col-md-7">
                              {objectData?.acquisition_method}{" "}
                            </div>
                          </li>
                          <li className="field-li row">
                            <div className="col-md-2">Original location</div>
                            <div className="col-md-7">
                              {`${
                                (objectData?.original_location_room &&
                                  objectData?.original_location_room
                                    ?.room_number) ||
                                (objectData?.original_location_storage_system &&
                                  objectData?.original_location_storage_system
                                    ?.storage_system_name) ||
                                (objectData?.original_location_storage_unit &&
                                  objectData?.original_location_storage_unit
                                    ?.storage_unit)
                              }`}
                              {(objectData?.original_location_room?.code ||
                                objectData?.original_location_storage_system
                                  ?.code ||
                                objectData?.original_location_storage_unit
                                  ?.code) && (
                                <span
                                  style={{
                                    color: "gray",
                                    marginLeft: "9px",
                                    fontSize: "16px",
                                  }}
                                >
                                  (
                                  {objectData?.original_location_room?.code ||
                                    objectData?.original_location_storage_system
                                      ?.code ||
                                    objectData?.original_location_storage_unit
                                      ?.code}
                                  )
                                </span>
                              )}
                            </div>
                          </li>
                          <li className="field-li row">
                            <div className="col-md-2">Transit location</div>
                            <div
                              style={{ position: "relative", display: "flex" }}
                              className="col-md-7"
                            >
                              {`${
                                (objectData?.transit_location_room &&
                                  objectData?.transit_location_room
                                    ?.room_number) ||
                                (objectData?.transit_location_storage_system &&
                                  objectData?.transit_location_storage_system
                                    ?.storage_system_name) ||
                                (objectData?.transit_location_storage_unit &&
                                  objectData?.transit_location_storage_unit
                                    ?.storage_unit)
                              }`}
                              {(objectData?.transit_location_room?.code ||
                                objectData?.transit_location_storage_system
                                  ?.code ||
                                objectData?.transit_location_storage_unit) && (
                                <span
                                  style={{
                                    color: "gray",
                                    marginLeft: "9px",
                                    fontSize: "16px",
                                    display: "flex",
                                    gap: "5px",
                                    alignItems: "center",
                                  }}
                                >
                                  {`(${
                                    objectData?.transit_location_room?.code
                                      ? objectData?.transit_location_room?.code
                                      : "" ||
                                        objectData
                                          ?.transit_location_storage_system
                                          ?.code
                                      ? objectData
                                          ?.transit_location_storage_system
                                          ?.code
                                      : "" ||
                                        objectData
                                          ?.transit_location_storage_unit?.code
                                      ? objectData
                                          ?.transit_location_storage_unit?.code
                                      : ""
                                  })`}

                                  <p
                                    style={{
                                      color: "blue",
                                      fontSize: "14px",
                                      top: "3px",
                                      right: "397px",
                                      cursor: "pointer",
                                    }}
                                    onClick={transitHistoryShowHandler}
                                  >
                                    See transit history
                                  </p>
                                </span>
                              )}
                            </div>{" "}
                          </li>
                          <li className="field-li row ">
                            <div className="col-md-2">Tags</div>
                            <div className="col-md-7">
                              <div className="tags">
                                {objectData?.tags?.map((iteam, index) => (
                                  <p key={index} className="p_tag">
                                    {iteam?.tag_name}
                                  </p>
                                ))}
                              </div>
                            </div>
                          </li>
                          <li className="field-li row ">
                            <div className="col-md-2">Funtion or usage</div>
                            <div className="col-md-7">
                              <div className="tags">
                                {objectData?.function_or_usages?.map(
                                  (iteam, index) => (
                                    <p key={index} className="p_tag">
                                      {iteam?.function_or_usage}
                                    </p>
                                  )
                                )}
                              </div>
                            </div>
                          </li>
                          <li className="field-li row">
                            <div className="col-md-2">
                              Historical description
                            </div>
                            <div className="col-md-10">
                              {objectData?.historical_description
                                ?.charAt(0)
                                .toUpperCase() +
                                objectData?.historical_description
                                  ?.slice(1)
                                  .toLowerCase()}
                            </div>
                          </li>
                          <li className="field-li row">
                            <div className="col-md-2">
                              Cultural significance
                            </div>
                            <div className="col-md-10">
                              {objectData?.cultural_significance
                                ?.charAt(0)
                                .toUpperCase() +
                                objectData?.cultural_significance
                                  ?.slice(1)
                                  .toLowerCase()}
                            </div>
                          </li>
                          <li className="field-li row">
                            <div className="col-md-2">Technique</div>
                            <div className="col-md-10">
                              {objectData?.technique?.charAt(0).toUpperCase() +
                                objectData?.technique?.slice(1).toLowerCase()}
                            </div>
                          </li>
                          <li className="field-li row">
                            <div
                              className="col-md-2"
                              style={{ overflowWrap: "break-word" }}
                            >
                              References/Bibliography
                            </div>
                            <div className="col-md-10">
                              {objectData?.references?.charAt(0).toUpperCase() +
                                objectData?.references?.slice(1).toLowerCase()}
                            </div>
                          </li>

                          <li className="field-li row">
                            <div
                              className="col-md-2"
                              style={{ overflowWrap: "break-word" }}
                            >
                              Ledger number
                            </div>
                            <div className="col-md-10">
                              <p>{objectData?.ledger_number}</p>
                            </div>
                          </li>
                          <li className="field-li row">
                            <div
                              className="col-md-2"
                              style={{ overflowWrap: "break-word" }}
                            >
                              Ledger image
                            </div>
                            <div className="col-md-10">
                              {objectData?.ledger_image && (
                                <div
                                  style={{
                                    height: "100px",
                                    width: "100px",
                                    borderRadius: "10px",
                                    border: "1px solid #EEEEEE",
                                    padding: "5px",
                                  }}
                                >
                                  <img
                                    onClick={() => {
                                      setShowEnlargeImage({
                                        show: true,
                                        image: objectData?.ledger_image,
                                        isEdit: false,
                                        title: "Ledger image",
                                      });
                                    }}
                                    src={objectData?.ledger_image}
                                    style={{
                                      height: "100%",
                                      width: "100%",
                                      objectFit: "contain",
                                    }}
                                    alt="ledger-image"
                                  />
                                </div>
                              )}
                            </div>
                          </li>
                          <li className="field-li row">
                            <div
                              className="col-md-2"
                              style={{ overflowWrap: "break-word" }}
                            >
                              Page number
                            </div>
                            <div className="col-md-10">
                              <p>{objectData?.page_number}</p>
                            </div>
                          </li>
                          <li className="field-li row">
                            <div
                              className="col-md-2"
                              style={{ overflowWrap: "break-word" }}
                            >
                              Old accession number
                            </div>
                            <div className="col-md-10">
                              <p>{objectData?.old_accession_number}</p>
                            </div>
                          </li>
                          <li className="field-li row">
                            <div
                              className="col-md-2"
                              style={{ overflowWrap: "break-word" }}
                            >
                              Page image
                            </div>
                            <div className="col-md-10">
                              {objectData?.page_image && (
                                <div
                                  style={{
                                    height: "100px",
                                    width: "100px",
                                    borderRadius: "10px",
                                    border: "1px solid #EEEEEE",
                                    padding: "5px",
                                  }}
                                >
                                  <img
                                    style={{
                                      height: "100%",
                                      width: "100%",
                                      objectFit: "contain",
                                    }}
                                    onClick={() => {
                                      setShowEnlargeImage({
                                        show: true,
                                        image: objectData?.page_image,
                                        isEdit: false,
                                        title: "Page image",
                                      });
                                    }}
                                    src={objectData?.page_image}
                                    alt="page-image"
                                  />
                                </div>
                              )}
                            </div>
                          </li>
                          <li className="field-li row">
                            <div
                              className="col-md-2"
                              style={{ overflowWrap: "break-word" }}
                            >
                              Ledger entry description
                            </div>
                            <div className="col-md-10">
                              <p>{objectData?.ledger_description}</p>
                            </div>
                          </li>
                          <li className="field-li row">
                            <div
                              className="col-md-2"
                              style={{ overflowWrap: "break-word" }}
                            >
                              Ledger entry translation
                            </div>
                            <div className="col-md-10">
                              <p>{objectData?.ledger_translation}</p>
                            </div>
                          </li>
                          <li className="field-li row">
                            <div
                              className="col-md-2"
                              style={{ overflowWrap: "break-word" }}
                            >
                              Ledger notes
                            </div>
                            <div className="col-md-10">
                              <p>{objectData?.ledger_notes}</p>
                            </div>
                          </li>

                          <li className="field-li row">
                            <div
                              className="col-md-2"
                              style={{ overflowWrap: "break-word" }}
                            >
                              Ledger entry images
                            </div>
                            <div
                              className="col-md-10"
                              style={{
                                display: "flex",
                                gap: "10px",
                                flexWrap: "wrap",
                              }}
                            >
                              {objectData?.ledger_entry_images?.map(
                                (liEntry) => (
                                  <div
                                    style={{
                                      height: "100px",
                                      width: "100px",
                                      borderRadius: "10px",
                                      border: "1px solid #EEEEEE",
                                      padding: "5px",
                                    }}
                                  >
                                    <img
                                      style={{
                                        height: "100%",
                                        width: "100%",
                                        objectFit: "contain",
                                      }}
                                      onClick={() => {
                                        const reorderedImages = [
                                          liEntry,
                                          ...objectData?.ledger_entry_images.filter(
                                            (img) =>
                                              img.entry_image !==
                                              liEntry.entry_image
                                          ),
                                        ];
                                        setShowEnlargeImage({
                                          show: true,
                                          image: reorderedImages,
                                          isEdit: false,
                                          title: "Entry image",
                                        });
                                      }}
                                      src={liEntry?.entry_image}
                                      alt="entry-image"
                                    />
                                  </div>
                                )
                              )}
                            </div>
                          </li>
                          {/* <li className='field-li row' >
                                                        <div className='col-md-2'>Ledger number</div>
                                                        <div className='col-md-7'>
                                                            <p></p>
                                                        </div>
                                                    </li>
                                                    <li className='field-li row' >
                                                        <div className='col-md-2'>Page number</div>
                                                        <div className='col-md-7'>
                                                            <p></p>
                                                        </div>
                                                    </li>
                                                    <li className='field-li row' >
                                                        <div className='col-md-2'>Ledger object ID</div>
                                                        <div className='col-md-7'>
                                                            <p></p>
                                                        </div>
                                                    </li>
                                                    <li className='field-li row' >
                                                        <div className='col-md-2'> Date of ledger entry</div>
                                                        <div className='col-md-7'>
                                                            <p></p>
                                                        </div>
                                                    </li>
                                                    <li className='field-li row' >
                                                        <div className='col-md-2'> Object entry description</div>
                                                        <div className='col-md-7'>
                                                            <p></p>
                                                        </div>
                                                    </li> */}
                          <li className="field-li row">
                            <div className="col-md-2"> Condition grading</div>
                            <div className="col-md-7">
                              {formikValues?.stability === 1 && (
                                <p
                                  style={{
                                    borderRadius: "5px",
                                    display: "flex",
                                    width: "25px",
                                    justifyContent: "center",
                                    backgroundColor:
                                      formikValues?.stability === 1
                                        ? "green"
                                        : "",
                                    color:
                                      formikValues?.stability === 1
                                        ? "#fff"
                                        : "",
                                  }}
                                >
                                  1
                                </p>
                              )}
                              {formikValues?.stability === 2 && (
                                <p
                                  style={{
                                    borderRadius: "5px",
                                    display: "flex",
                                    width: "25px",
                                    justifyContent: "center",
                                    backgroundColor:
                                      formikValues?.stability === 2
                                        ? "#FEBE10"
                                        : "",
                                    color:
                                      formikValues?.stability === 2
                                        ? "#fff"
                                        : "",
                                  }}
                                >
                                  2
                                </p>
                              )}
                              {formikValues?.stability === 3 && (
                                <p
                                  style={{
                                    borderRadius: "5px",
                                    display: "flex",
                                    width: "25px",
                                    justifyContent: "center",
                                    backgroundColor:
                                      formikValues?.stability === 3
                                        ? "orangered"
                                        : "",
                                    color:
                                      formikValues?.stability === 3
                                        ? "#fff"
                                        : "",
                                  }}
                                >
                                  3
                                </p>
                              )}
                              {formikValues?.is_emergency && (
                                <button
                                  type="button"
                                  style={{
                                    borderRadius: "5px",
                                    backgroundColor: formikValues?.is_emergency
                                      ? "#851A1A"
                                      : "#fff",
                                    color: formikValues?.is_emergency
                                      ? "#fff"
                                      : "#000",
                                    border: formik?.values?.is_emergency
                                      ? "none"
                                      : "1px solid black",
                                  }}
                                >
                                  Emergency
                                </button>
                              )}
                            </div>
                          </li>
                          <li className="field-li row">
                            <div className="col-md-2">Remarks </div>
                            <div className="col-md-7">
                              <p>
                                {formikValues?.remarks
                                  ? formikValues?.remarks
                                      ?.charAt(0)
                                      .toUpperCase() +
                                    formikValues?.remarks
                                      ?.slice(1)
                                      .toLowerCase()
                                  : ""}
                              </p>
                            </div>
                          </li>
                          {/* <li className='field-li row' >
                                                        <div className='col-md-2'>Stabilization guidelines </div>
                                                        <div className='col-md-7'>
                                                            <p>{formikValues?.stabilization_guidelines?.charAt(0).toUpperCase() +
                                                                formikValues?.stabilization_guidelines?.slice(1).toLowerCase()}</p>
                                                        </div>
                                                    </li>
                                                    <li className='field-li row' >
                                                        <div className='col-md-2'> Object handling guidelines</div>
                                                        <div className='col-md-7'>
                                                            <p>{formikValues?.object_handling_guidelines?.charAt(0).toUpperCase() + formikValues?.object_handling_guidelines?.slice(1).toLowerCase()}</p>
                                                        </div>
                                                    </li> */}
                          <li className="field-li row">
                            <div className="col-md-2">
                              {" "}
                              Graphical description{" "}
                            </div>
                            <div
                              className="col-md-7"
                              style={{ display: "flex", gap: "10px" }}
                            >
                              {formikValues?.graphical_represenatation?.map(
                                (li) => (
                                  <div
                                    style={{
                                      height: "100px",
                                      width: "100px",
                                      borderRadius: "10px",
                                      border: "1px solid #EEEEEE",
                                      padding: "5px",
                                    }}
                                  >
                                    <img
                                      onClick={() => {
                                        const reorderedImages = [
                                          li,
                                          ...formikValues?.graphical_represenatation?.filter(
                                            (liImage) =>
                                              liImage?.image !== li?.image
                                          ),
                                        ];
                                        setShowEnlargeImage({
                                          image: reorderedImages,
                                          isEdit: false,
                                          title: "Graphical description",
                                          show: true,
                                        });
                                      }}
                                      src={li?.image}
                                      style={{
                                        height: "100%",
                                        width: "100%",
                                        objectFit: "contain",
                                      }}
                                      alt="graphical-represantation"
                                    />
                                  </div>
                                )
                              )}
                            </div>
                          </li>
                          <li className="field-li row">
                            <div className="col-md-2">Physical description</div>
                            <div className="col-md-7">
                              {formikValues?.physical_description}
                            </div>
                          </li>
                          <li className="field-li row">
                            <div className="col-md-2">Material techniques</div>
                            <div className="col-md-7">
                              {formikValues?.techinques_used}
                            </div>
                          </li>
                        </ul>
                        {/* </div> */}
                      </div>

                      <div className="Strategic-box">
                        <div className="Strategic-container">
                          <div className="strategic-header">
                            <p>Condition assessment</p>
                          </div>
                          <div
                            className="Strategic-box"
                            style={{
                              position: "relative",
                              backgroundColor:
                                formikValues?.stratigraphic_assessment &&
                                formikValues.stratigraphic_assessment.length > 0
                                  ? "#F0F8FF"
                                  : "#FFFFFF", // White background when no data
                              padding: "20px 10px 25px 10px",
                              borderRadius: "7px",
                            }}
                          >
                            <div className="strategic-accordion-container">
                              {formikValues?.stratigraphic_assessment &&
                              formikValues.stratigraphic_assessment.length >
                                0 ? (
                                formikValues.stratigraphic_assessment.map(
                                  (li, index) => {
                                    console.log(li, "liassessment");

                                    return (
                                      <Accordion
                                        className="strategic-accordion"
                                        key={index}
                                      >
                                        <Accordion.Item eventKey="0">
                                          <Accordion.Header
                                            className="strategic-accordion-option-header"
                                            style={{
                                              zIndex: 0,
                                              position: "relative",
                                            }}
                                          >
                                            <div className="assessment-view-header">
                                              <div className="assessment-view-name">
                                                {li?.assessment_name &&
                                                  li.assessment_name
                                                    .charAt(0)
                                                    .toUpperCase() +
                                                    li.assessment_name
                                                      .slice(1)
                                                      .toLowerCase()}
                                              </div>

                                              <div className="assessment-view-static-field">
                                                <span className="field-label">
                                                  Materials:{" "}
                                                </span>
                                                <Tooltip
                                                  title={
                                                    li?.assessment_materials
                                                      ?.length > 0
                                                      ? li.assessment_materials
                                                          .map(
                                                            (item) =>
                                                              item?.label
                                                          )
                                                          .join(", ")
                                                      : "-"
                                                  }
                                                >
                                                  <span className="field-value material-truncate">
                                                    {li?.assessment_materials
                                                      ?.length > 0
                                                      ? li.assessment_materials
                                                          .map(
                                                            (item) =>
                                                              item?.label
                                                          )
                                                          .join(", ")
                                                      : "-"}
                                                  </span>
                                                </Tooltip>
                                              </div>

                                              <div className="assessment-view-static-field">
                                                <span className="field-label">
                                                  Condition:{" "}
                                                </span>
                                                <span className="field-value">
                                                  {li?.assessment_is_emergency
                                                    ? "Emergency"
                                                    : li?.assessment_stability ||
                                                      "-"}
                                                </span>
                                              </div>
                                            </div>
                                          </Accordion.Header>
                                          <Accordion.Body
                                            style={{ marginLeft: "32px" }}
                                            className="strategic-option-container"
                                          >
                                            <div className="assessment-view-cards-container">
                                              {li?.assessment_details?.length >
                                              0 ? (
                                                li?.assessment_details?.map(
                                                  (
                                                    valuesOfAssessment,
                                                    detailIndex
                                                  ) => {
                                                    const evidenceImageOff =
                                                      valuesOfAssessment?.evidence_images?.filter(
                                                        (lioFassesment) =>
                                                          lioFassesment?.image
                                                      );
                                                    return (
                                                      <div
                                                        className="assessment-view-card"
                                                        key={detailIndex}
                                                      >
                                                        <span className="card-label">
                                                          Degradation name
                                                        </span>
                                                        <div className="degradation-name-view">
                                                          {valuesOfAssessment?.degradation ||
                                                            "No data"}
                                                        </div>

                                                        {evidenceImageOff?.length >
                                                        0 ? (
                                                          <div className="evidence-images-row">
                                                            {evidenceImageOff.map(
                                                              (
                                                                imageValue,
                                                                evidIndex
                                                              ) => (
                                                                <div
                                                                  className="evidence-image-item"
                                                                  key={
                                                                    evidIndex
                                                                  }
                                                                  onClick={() => {
                                                                    const reorderedImagesEvidence =
                                                                      [
                                                                        imageValue,
                                                                        ...evidenceImageOff?.filter(
                                                                          (
                                                                            evidenceImage
                                                                          ) =>
                                                                            evidenceImage?.image !==
                                                                            imageValue.image
                                                                        ),
                                                                      ];
                                                                    setShowEnlargeImage(
                                                                      {
                                                                        image:
                                                                          reorderedImagesEvidence,
                                                                        isEdit: false,
                                                                        title:
                                                                          "Condition assessment",
                                                                        show: true,
                                                                      }
                                                                    );
                                                                  }}
                                                                >
                                                                  <img
                                                                    src={
                                                                      imageValue.image
                                                                    }
                                                                    alt="Evidence"
                                                                  />
                                                                  {imageValue.caption && (
                                                                    <Tooltip
                                                                      title={
                                                                        imageValue.caption
                                                                      }
                                                                    >
                                                                      <div className="caption-overlay">
                                                                        {
                                                                          imageValue.caption
                                                                        }
                                                                      </div>
                                                                    </Tooltip>
                                                                  )}
                                                                </div>
                                                              )
                                                            )}
                                                          </div>
                                                        ) : (
                                                          <div
                                                            style={{
                                                              marginBottom:
                                                                "20px",
                                                              color: "gray",
                                                              fontStyle:
                                                                "italic",
                                                            }}
                                                          >
                                                            No evidence images
                                                          </div>
                                                        )}

                                                        <span className="card-label">
                                                          Description
                                                        </span>
                                                        <div className="description-view">
                                                          {valuesOfAssessment?.description
                                                            ? valuesOfAssessment?.description
                                                            : ""}
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                )
                                              ) : (
                                                <div
                                                  style={{
                                                    textAlign: "center",

                                                    color: "gray",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                  }}
                                                >
                                                  <p style={{ color: "gray" }}>
                                                    No degradation
                                                  </p>
                                                </div>
                                              )}
                                            </div>
                                          </Accordion.Body>
                                        </Accordion.Item>
                                      </Accordion>
                                    );
                                  }
                                )
                              ) : (
                                <div
                                  style={{
                                    textAlign: "center",

                                    color: "gray",
                                    fontSize: "16px",
                                  }}
                                >
                                  There are no records to display
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style={{ paddingBottom: "50px" }}>
                        <p style={{ fontWeight: "600", paddingBottom: "25px" }}>
                          Investigation details
                        </p>
                        <div className="Proposed-treatment-admin">
                          <div
                            style={{
                              maxHeight: "350px",
                              overflowY: "auto",
                              border: "1px solid #ddd",
                              borderRadius: "7px",
                              width: "97%",
                            }}
                          >
                            <Table
                              className="table_admin"
                              borderless
                              style={{ width: "100%" }}
                            >
                              <thead>
                                <tr>
                                  <th
                                    style={{
                                      backgroundColor: "rgb(180, 211, 240)",
                                      width: "19%",
                                    }}
                                  >
                                    Investigation name
                                  </th>
                                  <th
                                    style={{
                                      backgroundColor: "rgb(180, 211, 240)",
                                      width: "13%",
                                    }}
                                  >
                                    Investigation Id
                                  </th>
                                  <th
                                    style={{
                                      backgroundColor: "rgb(180, 211, 240)",
                                      width: "18%",
                                    }}
                                  >
                                    Invasive/Non invasive
                                  </th>
                                  <th
                                    style={{
                                      backgroundColor: "rgb(180, 211, 240)",
                                      width: "25%",
                                    }}
                                  >
                                    Sample details
                                  </th>
                                  <th
                                    style={{
                                      backgroundColor: "rgb(180, 211, 240)",
                                    }}
                                  >
                                    Result
                                  </th>
                                </tr>
                              </thead>

                              <tbody>
                                {formikValues?.investigation_details &&
                                formikValues?.investigation_details?.length >
                                  0 ? (
                                  formikValues.investigation_details.map(
                                    (li, index) => (
                                      <tr
                                        style={{
                                          borderBottom: "1px solid lightgray",
                                        }}
                                        key={index}
                                      >
                                        <td style={{ paddingTop: "20px" }}>
                                          {li.investigation_name}
                                        </td>
                                        <td style={{ paddingTop: "20px" }}>
                                          {li.investigation_id}
                                        </td>
                                        <td style={{ paddingTop: "20px" }}>
                                          {li.invasive_or_non_vasive
                                            ? "Invasive"
                                            : "Non invasive"}
                                        </td>
                                        <td style={{ paddingTop: "20px" }}>
                                          {li.sample_details}
                                        </td>
                                        <td style={{ paddingTop: "20px" }}>
                                          {li.result}
                                        </td>
                                      </tr>
                                    )
                                  )
                                ) : (
                                  <tr>
                                    <td
                                      colSpan="5"
                                      style={{
                                        textAlign: "center",
                                        padding: "20px",
                                        color: "gray",
                                      }}
                                    >
                                      There are no records to display
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </Table>
                          </div>
                        </div>
                      </div>
                      {/* <div>
                                                <ul style={{ paddingBottom: "20px" }} className="field-ul-admin">
                                                    <li className="field-li-admin-main row">
                                                        <div className="col-md-2">Investigation and analysis</div>

                                                        <div className="col-md-10">
                                                            <div className="row">
                                                                <div className="col-md-2" style={{ color: "black" }}>Investigation ID</div>
                                                                <div className="col-md-10" style={{ opacity: "0.5" }}>
                                                                    {formikValues?.investigation_id}
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-2" style={{ color: "black" }}>Invasive/non-Invasive</div>
                                                                <div className="col-md-10" style={{ opacity: "0.5" }}>
                                                                    {formikValues?.invasive_or_non_vasive ? "Invasive" : "Non Invasive"}
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-2" style={{ color: "black" }}>Sample details</div>
                                                                <div className="col-md-10">{formikValues?.sample_details}</div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-2" style={{ color: "black" }}>Result</div>
                                                                <div className="col-md-10">{formikValues?.result}</div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>




                                            </div> */}
                      <div style={{ paddingBottom: "50px" }}>
                        <p style={{ fontWeight: "600", paddingBottom: "25px" }}>
                          Proposed treatment
                        </p>
                        <div className="Proposed-treatment-admin">
                          <div
                            style={{
                              maxHeight: "350px",
                              overflowY: "auto",
                              border: "1px solid #ddd",
                              borderRadius: "7px",
                              width: "97%",
                            }}
                          >
                            <Table
                              className="table_admin"
                              borderless
                              style={{ width: "100%" }}
                            >
                              <thead>
                                <tr style={{ verticalAlign: "top" }}>
                                  <th
                                    style={{
                                      backgroundColor: "rgb(180, 211, 240)",
                                      paddingLeft: "29px",
                                      width: "7%",
                                      position: "sticky",
                                      zIndex: "2",
                                    }}
                                  >
                                    Step
                                  </th>
                                  <th
                                    style={{
                                      backgroundColor: "rgb(180, 211, 240)",
                                      width: "8%",
                                    }}
                                  >
                                    Degradation
                                  </th>
                                  <th
                                    style={{
                                      backgroundColor: "rgb(180, 211, 240)",
                                      width: "8%",
                                    }}
                                  >
                                    Action
                                  </th>
                                  <th
                                    style={{
                                      backgroundColor: "rgb(180, 211, 240)",
                                      width: "33%",
                                    }}
                                  >
                                    Tasks
                                  </th>
                                  <th
                                    style={{
                                      backgroundColor: "rgb(180, 211, 240)",
                                      width: "15%",
                                    }}
                                  >
                                    Conservation material
                                  </th>
                                  <th
                                    style={{
                                      backgroundColor: "rgb(180, 211, 240)",
                                      width: "7%",
                                    }}
                                  >
                                    Status
                                  </th>
                                  <th
                                    style={{
                                      backgroundColor: "rgb(180, 211, 240)",
                                      width: "9%",
                                    }}
                                  >
                                    Standard procedure
                                  </th>
                                </tr>
                              </thead>

                              <tbody>
                                {formikValues?.proposed_treatment &&
                                formikValues.proposed_treatment.length > 0 ? (
                                  formikValues.proposed_treatment.map(
                                    (li, index) => (
                                      <tr key={index}>
                                        <td
                                          style={{
                                            paddingLeft: "30px",
                                            paddingTop: "25px",
                                          }}
                                        >
                                          {li.step}
                                        </td>
                                        <td style={{ paddingTop: "20px" }}>
                                          {li.degradation_name}
                                        </td>
                                        <td style={{ paddingTop: "20px" }}>
                                          {li.action_name}
                                        </td>
                                        <td style={{ paddingTop: "20px" }}>
                                          {li.task}
                                        </td>
                                        <td style={{ paddingTop: "20px" }}>
                                          {li.conservation_materials}
                                        </td>
                                        <td style={{ paddingTop: "20px" }}>
                                          {li.status}
                                        </td>
                                        <td style={{ paddingTop: "20px" }}>
                                          {li.is_standered_procedure
                                            ? "yes"
                                            : "No"}
                                        </td>
                                      </tr>
                                    )
                                  )
                                ) : (
                                  <tr>
                                    <td
                                      colSpan="7"
                                      style={{
                                        textAlign: "center",
                                        padding: "20px",
                                        color: "gray",
                                      }}
                                    >
                                      There are no records to display
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </Table>
                          </div>
                        </div>
                      </div>
                      <ul className="field-ul">
                        <li className="field-li row">
                          <div className="col-md-2">Recommended storage</div>
                          <div className="col-md-8">
                            {formikValues?.recommended_storage}{" "}
                          </div>
                        </li>
                      </ul>
                    </div>
                  </Row>
                </div>
                {transitHistory.show && (
                  <TransitModal
                    show={transitHistory.show}
                    setTransitHistory={setTransitHistory}
                    handleClose={() => setTransitHistory({ show: false })}
                    museumObjectId={id}
                  />
                )}
                {/* <TransitModal
                  show={transitHistory.show}
                  setTransitHistory={setTransitHistory}
                  handleClose={() => setTransitHistory({ show: false })}
                  museumObjectId={id}
                />{" "} */}
                <Commentdrawer
                  fromNotification={fromNotification}
                  id={id}
                  isOpen={isOpen}
                  setIsOpen={setIsOpen}
                  toggleDrawer={toggleDrawer}
                />
                <Objecthistorydrawer
                  id={id}
                  isOpenhistory={isOpenhistory}
                  setIsOpenhistory={setIsOpenhistory}
                  toggleDrawerhistory={toggleDrawerhistory}
                />
              </Form>
            )}
          </Container>
        </div>
      </section>
    </>
  );
};
export default Objectadmindetails;
